<div class="modal-dialog-header">
  <button
    type="button"
    tabindex="-1"
    class="close float-right"
    data-dismiss="modal"
    aria-label="Close"
    (click)="onCancel()"
    title="Close form and discard any changes."
  >
    <i class="far fa-times"></i>
  </button>
  <h3 mat-dialog-title>Check In Items</h3>
</div>

<mat-dialog-content class="modal-dialog-content">
  <div class="main-content">
    <p class="intro-text">
      You are about to check in <strong>{{ data.itemCount }}</strong> item(s) from the cart.
    </p>
    
    <div class="action-section">
      <h4>This action will:</h4>
      <ul class="action-list">
        <li>
          <i class="far fa-arrow-right"></i>
          Change the status from <span class="status-badge shipped">Shipped</span> to <span class="status-badge in-stock">In Stock</span>
        </li>
        <li>
          <i class="far fa-arrow-right"></i>
          Set the last inventoried date to <span class="date-badge">current date and time</span>
        </li>
        <li>
          <i class="far fa-arrow-right"></i>
          Remove all items from the cart
        </li>
      </ul>
    </div>
  </div>
</mat-dialog-content>

<div class="modal-dialog-footer">
  <button type="button" class="btn btn-default float-left btn-sm" (click)="onCancel()">
    <i class="far fa-times"></i> Cancel
  </button>
  <button type="button" class="btn btn-primary float-right btn-sm" (click)="onConfirm()">
    <i class="far fa-check"></i> Check In Items
  </button>
</div>
